import styled, {css} from "styled-components"

import BaseCard from "@irati/ui/src/experimental/Card"

export const Card = styled(BaseCard)`
  ${({theme}) => css`
    padding: ${theme.spacing.three};
    ${theme.mediaQueries.minWidthMedia.desktop`
      padding: ${theme.spacing.eight};
    `}
  `}
`
